import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/restaurant/merchant/order',
    name: 'resOrder',
    meta,
    redirect: { name: 'resOrder' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'shopOrderList',
            name: `${pre}shopOrderList`,
            component: _import('restaurant/merchant/order/shopOrderList'),
            meta: {
                ...meta,
                title: '订单列表'
            }
        }
    ])('resOrder-')
}
